"use strict";
var $ = require("../internals/export");
var isIntegralNumber = require("../internals/is-integral-number");
var abs = Math.abs;
$({ target: "Number", stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber(number) && abs(number) <= 9007199254740991;
  }
});
